// Booking-scoped EMR routes pick the site database from this header.
export const siteHeaders = (siteId: string) => ({ 'Database-Connection': siteId })
